import React, { useState } from 'react';
import Classes from './style.module.css';

import { IoCloudUploadOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5"
import { useDropzone } from "react-dropzone";
import toast from 'react-hot-toast';
import errorHandler from '../../assets/utils/ErrorHandler';
import axios from "axios";
import { baseURL } from '../../assets/constants/baseUrl';

const TicketFileUploader = ({pic:uploadedFile,setPic:setUploadedFile}) => {
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    // const [uploadedFile, setUploadedFile] = useState(null);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),
        maxFiles: 1,
        maxSize: 15 * 1024 * 1024,
        accept: {
            'image/jpeg': ['.jpg', '.jpeg', '.jfif'],
            'image/png': ['.png'],
            'image/webp': ['.webp'],
         },
        onDropRejected: () => toast.error("فقط تصویر JPEG، PNG یا WebP تا حجم ۱۵ مگابایت مجاز است."),
    });

    const handleFileUpload = async (files) => {
        if (files.length !== 1 || loading) return;
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("file", file);
        });
        try {
            setLoading(true);
            const response = await axios.post(
                `${baseURL}file/upload/user/guest?ticketGuestMode=true`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("UserToken")}`,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setProgress(percentCompleted);
                    },
                }
            );
            setUploadedFile(response.data.file);
        } catch (error) {
            errorHandler(error);
            setProgress(0);
        } finally {
            setLoading(false);
            setProgress(0);
        }
    };

    const handleremove = (e) => {
        e.stopPropagation();
        setUploadedFile();
    };

    return (
        <div className={Classes.uploaderContainer}>
            <span>فایل ضمیمه</span>
            <div
                {...getRootProps()}
                className={`${Classes.uploader}`}
            >
                <input {...getInputProps()} />
                {uploadedFile ? (
                    <div className={Classes.imagePreviewWrapper}>
                        <img
                            src={`${baseURL}file/get/${uploadedFile.name}`}
                            alt="Preview"
                            className={Classes.imagePreview}
                        />
                        <button
                            type="button"
                            className={Classes.removeButton}
                            onClick={handleremove}
                        >
                            <IoClose size={20} />
                        </button>
                    </div>
                ) : (
                    <>
                        <IoCloudUploadOutline size={60} />
                        {!uploadedFile && (
                            <p>
                                {loading ? `درحال بارگزاری ${progress}%` : "بارگزاری فایل"}
                            </p>
                        )}

                    </>
                )}
            </div>
        </div>
    )
}

export default TicketFileUploader
